import type { Note, NoteInput } from '@/utils/types';

const API_BASE = '/api/v1/notes';

async function handleResponse<T>(res: Response): Promise<T> {
  const data = await res.json();
  if (!res.ok) {
    throw new Error(
      (data && typeof data.msg === 'string' ? data.msg : null) || res.statusText
    );
  }
  return data as T;
}

export async function getNotes(): Promise<Note[]> {
  const res = await fetch(API_BASE);
  return handleResponse<Note[]>(res);
}

export async function getNote(id: number): Promise<Note> {
  const res = await fetch(`${API_BASE}/${id}`);
  return handleResponse<Note>(res);
}

export async function createNote(data: NoteInput): Promise<Note> {
  const res = await fetch(API_BASE, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
  return handleResponse<Note>(res);
}

export async function updateNote(id: number, data: NoteInput): Promise<Note> {
  const res = await fetch(`${API_BASE}/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
  return handleResponse<Note>(res);
}

export async function deleteNote(
  id: number
): Promise<{ msg: string; note: Note }> {
  const res = await fetch(`${API_BASE}/${id}`, { method: 'DELETE' });
  return handleResponse<{ msg: string; note: Note }>(res);
}
